import { useTranslation } from 'react-i18next';
import { DetailsListView, EntityGridListProps } from '../../../../Common/DetailsList/DetailListView';
import { DateTime } from 'luxon';
import { Icon } from '@fluentui/react';

export const DirectSettlementsGridList = (props: EntityGridListProps) => {
  const { t } = useTranslation();

  const formatActivo = (item: any) => {
    if (item.lidasinc_activo === true) {
      return <Icon iconName="CheckMark" className="color-success" />;
    } else {
      return <Icon iconName="Cancel" className="color-error" />;
    }
  };

  const formatDateString = (dateString: string) => { // YYYYMM
    return <span>{DateTime.fromFormat(dateString, 'yyyyMM').toFormat('MM/yyyy')}</span>;
  };

  const columns = [
    {
      fieldName: 'lidasinc_id',
      name: t('ID'),
      maxWidth: 60,
      minWidth: 60,
    },
    {
      fieldName: 'lidasinc_periodo',
      name: t('Período'),
      _onRender: (item: any) => formatDateString(item.lidasinc_periodo),
      maxWidth: 50,
      minWidth: 50,
    },
    {
      fieldName: 'lidasinc_fecha_creacion',
      name: t('Fecha de carga'),
      maxWidth: 100,
      minWidth: 100,
    },
/*     {
      fieldName: 'lidasinc_importe_total',
      name: t('Importe total'),
      _onRender: (item: any) => item.lidasinc_importe_total ? `S/. ${item.lidasinc_importe_total}` : '',
      maxWidth: 80,
      minWidth: 80,
    }, */
    {
      fieldName: 'lidasinc_col_nombres_completos',
      name: t('Generada por'),
      minWidth: 350,
      maxWidth: 350,
    },
    {
      fieldName: 'lidasinc_tipo_liquidacion',
      name: t('Tipo de liquidación'),
      maxWidth: 100,
      minWidth: 100,
    },
    {
      fieldName: 'lidasinc_estado',
      name: t('Estado'),
      maxWidth: 60,
      minWidth: 60,
    },
    {
      fieldName: 'lidasinc_activo',
      name: t('Activa'),
      _onRender: (item: any) => formatActivo(item),
      maxWidth: 20,
      minWidth: 20,
    },
  ];
  return (
    <>
      <DetailsListView
        changeBlockUI={props.changeBlockUI}
        keyList={props.keyList}
        onClickCardMode={() => props.onClickCardMode()}
        onClickGridMode={() => props.onClickGridMode()}
        mode={props.mode}
        title={t('Liquidaciones Directas')}
        // virtualize={true}
        cols={columns}
        isGridList={true}
        courier={props.courier}
        listFilters={[]}
        quickFilters={props.quickFilters}
        onItemClick={props.onItemClick}
        baseUrl={props.baseUrl}
      ></DetailsListView>
    </>
  );
};
